import { apiRequest } from './request'

export interface CnpjResponse {
    cnpj: string
    razaoSocial: string
    nomeFantasia: string
    logradouro: string
    numero: string
    complemento: string
    bairro: string
    municipio: string
    uf: string
    cep: string
    email: string
    telefone: string
    situacaoCadastral: string
    atividadePrincipal: string
}

export const fetchCnpj = async (cnpj: string): Promise<CnpjResponse | null> => {
    const cleanCnpj = cnpj.replace(/\D/g, '')

    if (cleanCnpj.length !== 14) return null

    try {
        const response = await apiRequest<CnpjResponse>(
            `utils/cnpj/${cleanCnpj}`,
            {},
            'get',
        )

        if (!response.success || !response.result) return null

        return response.result
    } catch {
        return null
    }
}
